import { render, staticRenderFns } from "./GroupEligibiltiyConfirmation.vue?vue&type=template&id=2a0dcb98"
import script from "./GroupEligibiltiyConfirmation.vue?vue&type=script&lang=js"
export * from "./GroupEligibiltiyConfirmation.vue?vue&type=script&lang=js"
import style0 from "../assets/css/confirm_eligibility.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports